/**
 * SALES-MARKETING-WORKSPACE-001 — employee self-service (Leave / IT Support / Policies)
 * rendered inside the Sales & Marketing CRM shell. Pure navigation: the shared
 * MyWorkspace component and its backend endpoints keep their own RBAC.
 */
import React from 'react';
import { useNavigate } from 'react-router-dom';
import MyWorkspace from '../../components/hr/MyWorkspace';
import { useAuth } from '../../App';

export default function CrmMyWorkspacePage() {
  const navigate = useNavigate();
  const { user } = useAuth();
  return (
    <div data-testid="crm-my-workspace">
      <MyWorkspace currentUser={user} onNavigateBack={() => navigate('/crm')} embedded darkSkin={false} />
    </div>
  );
}
